export default "__VITE_PUBLIC_ASSET__4b60fd14__"